import { makeAssistantToolUI } from '@assistant-ui/react'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { LakeSearchDocumentsByNameView } from '@/components/agent/tools/LakeSearchDocumentsByNameView'
import {
  type LakeSearchDocumentsByNameArgs,
  type LakeSearchDocumentsByNameResult,
  parseResult,
} from './lake-search-documents-by-name'

type Status = { type: 'running' | 'complete' | 'incomplete' | string }

interface LakeSearchDocumentsByNameRenderProps {
  args: LakeSearchDocumentsByNameArgs
  result?: LakeSearchDocumentsByNameResult | string
  status: Status
}

/**
 * Connected `lake_search_documents_by_name` tool card: parses the backend
 * payload and wires document clicks to `/data?doc=<id>` (which opens the lake
 * document detail sheet), handing pure data to LakeSearchDocumentsByNameView.
 */
function LakeSearchDocumentsByNameRender({
  args,
  result,
  status,
}: LakeSearchDocumentsByNameRenderProps) {
  const navigate = useNavigate()

  const running = status.type === 'running'
  const parsed = useMemo(() => parseResult(result), [result])
  const errored = Boolean(parsed?.error) || status.type === 'incomplete'

  const onOpenDocument = (documentId: string) => {
    navigate(`/data?doc=${encodeURIComponent(documentId)}`)
  }

  return (
    <LakeSearchDocumentsByNameView
      args={args}
      parsed={parsed}
      running={running}
      errored={errored}
      onOpenDocument={onOpenDocument}
    />
  )
}

export const LakeSearchDocumentsByNameToolUI = makeAssistantToolUI<
  LakeSearchDocumentsByNameArgs,
  LakeSearchDocumentsByNameResult | string
>({
  toolName: 'lake_search_documents_by_name',
  render: LakeSearchDocumentsByNameRender,
})
